import {
  Button,
  ChevronLeftLargeIcon,
  ChevronRightLargeIcon,
  DateRangePicker,
  Flex,
} from '@cognite/cogs.js-v10';
import type dayjs from 'dayjs';
import type { TFunction } from 'i18next';

interface Props {
  handlePreviousWeekClick: () => void;
  handleNextWeekClick: () => void;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  isNextWeekDisabled: boolean;
  translationFunction: TFunction;
  dateFormat: 'YYYY/MM/DD' | 'MM/DD/YYYY' | 'DD/MM/YYYY';
}

export const SchedulesWeekPickerUi = ({
  handlePreviousWeekClick,
  handleNextWeekClick,
  startDate,
  endDate,
  isNextWeekDisabled,
  translationFunction,
  dateFormat,
}: Props) => {
  return (
    <Flex gap={4} data-testid="schedules-week-picker">
      <Button
        onClick={handlePreviousWeekClick}
        icon={<ChevronLeftLargeIcon />}
        type="ghost"
        aria-label={translationFunction(
          'SCHEDULES_WEEK_PICKER_PREVIOUS_WEEK',
          'Previous week'
        )}
      />
      <DateRangePicker
        data-testid="schedules-week-picker-dates"
        disableFuture
        readOnly
        value={[startDate, endDate]}
        format={dateFormat}
      />
      <Button
        onClick={handleNextWeekClick}
        icon={<ChevronRightLargeIcon />}
        type="ghost"
        disabled={isNextWeekDisabled}
        aria-label={translationFunction(
          'SCHEDULES_WEEK_PICKER_NEXT_WEEK',
          'Next week'
        )}
      />
    </Flex>
  );
};
